import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Checkbox, Label, Modal, TextInput, Textarea } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import useInputValidation from "../../hooks/useInputValidation";
import { useSidebar } from "../../context/SidebarOpenContext";

function Customer() {
    const navigate = useNavigate();
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({
        cname: "",
        customer_no: "",
        phoneno: "",
        address: "",
        gst_no: "",
        gst_type: "", // optional if derived
    });

    const [EditInput, setEditInput] = useState({
        id: "",
        cname: "",
        customer_no: "",
        phoneno: "",
        address: "",
        gst_no: "",
        gst_type: "",
    });
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[A-Z]{1}[A-Z0-9]{1}$/;
    const [gstError, setGstError] = useState('');
    const [Customer, setCustomer] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();

    useEffect(() => {
        fetchcustomer();
    }, []);


    const onChangeValue = (e) => {
        const { name, value } = e.target;
        const updatedInput = { ...Input, [name]: value };

        if (name === "gst_no") {
            updatedInput.gst_type = value.startsWith("33") ? "GST" : "IGST";
        }
        if (name === "gst_no") {
            if (value === "") {
                setGstError("GST No is required");
            } else if (!gstRegex.test(value)) {
                setGstError("Invalid GST format");
            } else {
                setGstError("");
            }
        }
        handleChange(e);
        setInput(updatedInput);
    };


    const onEditChangeValue = (e) => {
        handleChange(e);
        const { name, value } = e.target;
        const updatedCustomer = { ...EditInput, [name]: value };

        if (name === "gst_no") {
            const prefix = value.slice(0, 2);
            updatedCustomer.gst_type = prefix === "33" ? "GST" : "IGST";
        }
        if (name === "gst_no") {
            if (value === "") {
                setGstError("GST No is required");
            } else if (!gstRegex.test(value)) {
                setGstError("Invalid GST format");
            } else {
                setGstError("");
            }
        }
        setEditInput(updatedCustomer);
    };


    const fetchcustomer = async () => {
        try {
            const response = await axios.get("master/buyers");
            const CustomerData = response.data;
            setCustomer(CustomerData);
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    const addCustomer = async (event) => {
        event.preventDefault();
        try {
            axios
                .post(`master/buyers`, {
                    customer_name: Input.cname,
                    customer_no: Input.customer_no,
                    phone_no: Input.phoneno,
                    gst_no: Input.gst_no,
                    gst_type: Input.gst_type,
                    address: Input.address,
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Customer  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setAddModal(false);
                        fetchcustomer();

                    } else if (res.data.success === 2 || res.data.success === 3 || res.data.success === 4) {
                        Swal.fire({
                            icon: "error",
                            text: res.data.message,
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const UpdateCustomer = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/buyers/${EditInput.id}`, {
                    customer_name: EditInput.cname,
                    customer_no: EditInput.customer_no,
                    phone_no: EditInput.phoneno,
                    id: EditInput.id,
                    gst_no: EditInput.gst_no,
                    gst_type: EditInput.gst_type,
                    address: EditInput.address
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Customer  Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchcustomer();
                    } else if (res.data.success === 2 || res.data.success === 3 || res.data.success === 4) {
                        Swal.fire({
                            icon: "error",
                            text: res.data.message,
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletCustomer = async () => {
        try {
            axios.delete(`master/buyers/${EditInput.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Customer  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchcustomer();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Customer)
        ? Customer.map((Cus) => ({
            id: Cus.customer_id,
            cname: Cus.customer_name,
            customer_no: Cus.customer_no,
            phoneno: Cus.phone_no,
            gst_no: Cus.gst_no,
            gst_type: Cus.gst_type,
            address: Cus.address,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setEditInput({
                        id: Cus.customer_id,
                        cname: Cus.customer_name,
                        customer_no: Cus.customer_no,
                        phoneno: Cus.phone_no,
                        gst_no: Cus.gst_no,
                        gst_type: Cus.gst_type,
                        address: Cus.address,
                    });
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setEditInput({ id: Cus.customer_id }) }} />
            </div>)
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Customer Name", selector: (row) => row.cname, sortable: true },
        { name: "Customer Id", selector: (row) => row.customer_no },
        { name: "Phone No", selector: (row) => row.phoneno, sortable: true },
        { name: "GST No", selector: (row) => row.gst_no, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >

            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Customer</Button>
                    <ReusableDataTable
                        title="Customer List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Customer</h3>
                        <form onSubmit={addCustomer}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.cname && "failure"} value="Customer Name" />
                                </div>
                                <TextInput
                                    id="cname"
                                    name="cname"
                                    placeholder=""
                                    type="text"
                                    required
                                    color={errors.cname && "failure"}
                                    refer={
                                        errors.cname && (
                                            <>
                                                <span className="font-medium"></span> {errors.cname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[A-Za-z\s]*$"

                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.customer_no && "failure"} value="Customer Id" />
                                </div>
                                <TextInput
                                    id="customer_no"
                                    name="customer_no"
                                    placeholder=""
                                    type="text"
                                    required
                                    color={errors.customer_no && "failure"}
                                    refer={
                                        errors.customer_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.customer_no}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}

                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Phone Number" color={errors.phoneno && "failure"} />
                                </div>
                                <TextInput
                                    id="phoneno"
                                    color={errors.phoneno && "failure"}
                                    name="phoneno"
                                    type="text"
                                    required
                                    maxLength={10}
                                    refer={
                                        errors.phoneno && (
                                            <>
                                                <span className="font-medium"></span> {errors.phoneno}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[6-9]\d{9}$" />
                            </div>

                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_no" value="GST No" />
                                </div>
                                <TextInput
                                    id="gst_no"
                                    name="gst_no"
                                    type="text"
                                    value={Input.gst_no}
                                    onChange={onChangeValue}
                                    color={gstError ? 'failure' : 'default'}
                                    refer={gstError && <span>{gstError}</span>}
                                />
                            </div>


                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_type">GST Type : {Input.gst_type}</Label>
                                </div>
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="address" value="Address" />
                                </div>
                                <Textarea
                                    id="address"
                                    name="address"
                                    required
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Customer</h3>
                        <form onSubmit={UpdateCustomer}>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.cname && "failure"} value="Customer Name" />
                                </div>
                                <TextInput
                                    id="cname"
                                    name="cname"
                                    placeholder=""
                                    type="text"
                                    required
                                    onChange={onEditChangeValue}
                                    value={EditInput.cname}
                                    color={errors.cname && "failure"}
                                    refer={
                                        errors.cname && (
                                            <>
                                                <span className="font-medium"></span> {errors.cname}
                                            </>
                                        )
                                    }
                                    pattern="^[A-Za-z\s]*$"

                                />
                            </div>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.customer_no && "failure"} value="Customer Id" />
                                </div>
                                <TextInput
                                    id="customer_no"
                                    name="customer_no"
                                    placeholder=""
                                    type="text"
                                    required
                                    onChange={onEditChangeValue}
                                    value={EditInput.customer_no}
                                    color={errors.customer_no && "failure"}
                                    refer={
                                        errors.customer_no && (
                                            <>
                                                <span className="font-medium"></span> {errors.customer_no}
                                            </>
                                        )
                                    }


                                />
                            </div>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Phone Number" />
                                </div>
                                <TextInput
                                    id="phoneno"
                                    name="phoneno"
                                    value={EditInput.phoneno}
                                    color={errors.phoneno && "failure"}
                                    type="text"
                                    required
                                    maxLength={10}
                                    refer={
                                        errors.phoneno && (
                                            <>
                                                <span className="font-medium"></span> {errors.phoneno}
                                            </>
                                        )
                                    }
                                    onChange={onEditChangeValue}
                                    pattern="^\d{10}$" />

                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_no" value="GST No" />
                                </div>
                                <TextInput
                                    id="gst_no"
                                    name="gst_no"
                                    type="text"
                                    value={EditInput.gst_no}
                                    onChange={onEditChangeValue}
                                />
                            </div>

                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="gst_type">GST Type : {EditInput.gst_type}</Label>
                                </div>
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="address" value="Address" />
                                </div>
                            <Textarea
                                id="address"
                                name="address"
                                value={EditInput.address}
                                onChange={onEditChangeValue}
                                required
                            />
                            </div>
                            <div className="mt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this Customer?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletCustomer()}>
                                {"Yes"}
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    );
}

export default Customer;